export default function Newsletter() {
  return (
    <section class="cf-section">
      <div
        class="mx-auto grid max-w-[var(--cf-content-max)] grid-cols-1 items-center gap-4 rounded-[20px] border border-[rgba(138,43,226,0.22)] px-9 py-9 sm:grid-cols-2 lg:px-14 lg:py-12"
        style={{
          background:
            'radial-gradient(60% 100% at 20% 50%, rgba(255,60,172,0.10), transparent 70%), radial-gradient(60% 100% at 90% 50%, rgba(0,229,255,0.10), transparent 70%), rgba(255,255,255,0.03)',
        }}
      >
        {/* Text */}
        <div>
          <div class="mb-1.5 font-rajdhani text-[11px] font-extrabold uppercase tracking-[2.4px] text-[var(--cf-accent)]">
            Stay in the loop
          </div>
          <h4 class="mb-1.5 font-bebas text-[28px] tracking-[1px] text-white" style={{ 'line-height': '1.05' }}>
            Get new character drops first.
          </h4>
          <p class="text-[13px] leading-[1.5] text-[rgba(255,255,255,0.55)]">
            No spam. Unsubscribe anytime. We send 1 email a week with what's new.
          </p>
        </div>

        {/* Form — pill container */}
        <form
          class="flex gap-2 rounded-full border border-[rgba(255,255,255,0.08)] p-1.5"
          style={{ background: 'rgba(11,11,15,0.6)' }}
          onSubmit={(e) => {
            e.preventDefault()
            const input = (e.target as HTMLFormElement).email as HTMLInputElement
            input.value = ''
          }}
        >
          <input
            name="email"
            type="email"
            required
            placeholder="you@example.com"
            class="h-[44px] min-w-0 flex-1 bg-transparent px-3.5 text-[14px] text-white outline-none placeholder:text-[rgba(255,255,255,0.4)]"
          />
          <button
            type="submit"
            class="h-[44px] whitespace-nowrap rounded-full px-5 font-rajdhani text-[12px] font-extrabold uppercase tracking-[1.4px] text-white transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_26px_rgba(255,60,172,0.32)]"
            style={{ background: 'var(--cf-grad-brand)' }}
          >
            Subscribe →
          </button>
        </form>
      </div>
    </section>
  )
}
